/**
 * Descarga del contenido de un log.
 *
 * No se puede usar un `<a href>` directo: la API exige el token de la sesión y
 * los enlaces del navegador no lo envían. Se pide con `fetch` (reutilizando el
 * proveedor de sesión del cliente HTTP) y se descarga el resultado como archivo.
 */

import { env } from '@/config/env';
import { getSessionProvider } from '@/lib/http/session-provider';

/** Descarga un archivo de log de la fuente indicada. */
export async function descargarArchivoLog(origen: string, nombre: string): Promise<void> {
  const token = getSessionProvider()?.getAccessToken();
  const url =
    `${env.apiUrl}/api/system_logs/${encodeURIComponent(nombre)}/descargar` +
    `?origen=${encodeURIComponent(origen)}`;

  const respuesta = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });

  if (!respuesta.ok) {
    throw new Error(
      respuesta.status === 404
        ? 'El archivo de log ya no existe.'
        : `No se pudo descargar el log (HTTP ${respuesta.status}).`,
    );
  }

  const blob = await respuesta.blob();
  const objectUrl = URL.createObjectURL(blob);
  const enlace = document.createElement('a');

  enlace.href = objectUrl;
  enlace.download = nombre;
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  URL.revokeObjectURL(objectUrl);
}
